<div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
  <!-- Título -->
  <div class="mb-3">
    <h5 class="mb-0"><b>Relatórios de Pedidos</b></h5>
    <small class="text-secondary">Selecione filtros e gere estatísticas</small>
  </div>

  <!-- Filtros -->
  <form [formGroup]="formFiltro" (ngSubmit)="gerarEstatisticas()">
    @if (erroPeriodo) { <p class="text-danger" role="alert">{{ erroPeriodo }}</p> }
    <div class="form-row">
      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Relatório:</b></label>
        <select class="form-control form-control-sm" formControlName="tela">
          @for (o of telaOpcoes; track o) {
            <option [value]="o.valor">{{ o.texto }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Filtrar por:</b></label>
        <select class="form-control form-control-sm" formControlName="filtro" (change)="alterarFiltro($event.target.value)">
          @for (o of filtroOpcoes; track o) {
            <option [value]="o.valor" [selected]="o.valor == f.filtro.value">{{ o.texto }}</option>
          }
        </select>
      </div>

      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Dt. Inicial:</b></label>
        <input class="form-control form-control-sm" type="text"
          ngbDatepicker #dt_ini="ngbDatepicker"
          (click)="dt_ini.toggle()" formControlName="dt_inicial" />
      </div>

      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Dt. Final:</b></label>
        <input [appPeriodoFinal]="formFiltro.controls['dt_inicial'].value" class="form-control form-control-sm" type="text"
          ngbDatepicker #dt_fim="ngbDatepicker"
          (click)="dt_fim.toggle()" formControlName="dt_final" />
      </div>

      @if (f.filtro.value == 2) {
        <div class="form-group col-sm-3">
          <label class="text-secondary"><b>Cliente:</b></label>
          <input class="form-control form-control-sm" type="text" formControlName="cliente" />
        </div>
      }

      @if (f.filtro.value == 3) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Pedido:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" formControlName="nro_pedido" />
        </div>
      }

      @if (f.filtro.value == 4) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Status:</b></label>
          <select class="form-control form-control-sm" formControlName="status">
            <option value="">Todos</option>
            @for (s of filtroStatus; track s) {
              <option [value]="s.valor">{{ s.texto }}</option>
            }
          </select>
        </div>
      }

      @if (f.filtro.value == 5) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro NF:</b></label>
          <input class="form-control form-control-sm" type="text" formControlName="nro_nf" />
        </div>
      }

      @if (f.filtro.value == 6) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Dt Fat. Inicial:</b></label>
          <input class="form-control form-control-sm" type="text"
            ngbDatepicker #dt_fat_ini="ngbDatepicker"
            (click)="dt_fat_ini.toggle()" formControlName="dt_fat_inicial" />
        </div>
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Dt Fat. Final:</b></label>
          <input [appPeriodoFinal]="formFiltro.controls['dt_fat_inicial'].value" class="form-control form-control-sm" type="text"
            ngbDatepicker #dt_fat_fim="ngbDatepicker"
            (click)="dt_fat_fim.toggle()" formControlName="dt_fat_final" />
        </div>
      }

      <div class="form-group col-sm-3">
        <label class="text-secondary"><b>Vendedor(a):</b></label>
        <app-vendedor-typeahead
          [vendedorSelecionado]="f.vendedor.value"
          (vendedorChange)="f.vendedor.setValue($event)">
        </app-vendedor-typeahead>
      </div>

      <div class="form-group col-sm-2">
        <label class="text-secondary">&nbsp;</label>
        <div>
          @if (f.tela.value !== 'PONTUACOES') {
            <button class="btn btn-primary btn_filtro" type="submit" [disabled]="gerandoStats">
              {{ gerandoStats ? 'Gerando...' : 'Gerar Estatísticas' }}
            </button>
          }
          @if (stats && f.tela.value !== 'PONTUACOES') {
            <button class="btn btn-success btn_filtro ml-1" type="button"
              (click)="exportarExcel()" [disabled]="excelExportando">
              {{ excelExportando ? 'Gerando...' : 'Exportar Excel' }}
            </button>
          }
          @if (f.tela.value === 'PONTUACOES') {
            <button class="btn btn-warning btn_filtro ml-1" type="button"
              (click)="exportarPontuacoes()" [disabled]="excelExportando">
              {{ excelExportando ? 'Gerando...' : 'Exportar Pontuações' }}
            </button>
          }
        </div>
      </div>
    </div>
  </form>

  <hr class="mt-2 mb-3" />

  <!-- Resultados -->
  @if (stats) {
    <div class="d-flex flex align-items-start">
      <!-- KPI Cards -->
      <div class="d-flex flex-wrap mb-3 mr-4 align-items-center">
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2"><i class="fa fa-truck quadros_numeros_icones"></i></div>
            <div class="quadros_numeros_textos">{{ stats.qtdePedidos }}<br />Qtde Pedidos</div>
          </div>
        </div>
        @if (stats.qtdePositivacao != null) {
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2"><i class="fa fa-thumbs-up quadros_numeros_icones"></i></div>
              <div class="quadros_numeros_textos">{{ stats.qtdePositivacao }}<br />Positivação</div>
            </div>
          </div>
        }
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2"><i class="fa fa-dollar quadros_numeros_icones"></i></div>
            <div class="quadros_numeros_textos">{{ stats.valorVendas | currency:'BRL' }}<br />Vendas Total</div>
          </div>
        </div>
        @if (usaLitragem) {
          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2"><i class="fa fa-filter quadros_numeros_icones"></i></div>
              <div class="quadros_numeros_textos">{{ stats.litragemTotal | currency:'BRL':'' }}<br />Litragem Total</div>
            </div>
          </div>
        }
        <div class="quadros_numeros_lg p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2"><i class="fa fa-dollar quadros_numeros_icones"></i></div>
            @if (usaLitragem) {
              <div class="quadros_numeros_textos">{{ valorTicketMedio | currency:'BRL':'' }}<br />Ticket Médio</div>
            }
            @if (!usaLitragem) {
              <div class="quadros_numeros_textos">{{ valorTicketMedio | currency:'BRL' }}<br />Ticket Médio</div>
            }
          </div>
        </div>
      </div>
      <!-- Estatísticas por Status (ao lado dos KPIs) -->
      @if (estatisticas.length > 0) {
        <div class="align-items-center">
          <div class="estatistica text-center p-2">
            <div><b>Estatísticas</b></div>
            <div class="estatistica_quadro mt-3">
              @for (estatistica of estatisticas; track estatistica) {
                <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                  <div class="estatistica_legenda mr-3" [ngClass]="estatistica.item"></div>
                  <div class="estatistica_legenda_descricao text-left">{{ estatistica.descricao }}</div>
                  <div class="estatistica_legenda_descricao text-right">{{ estatistica.valor | currency: 'BRL' }}</div>
                  @if (modelo_tela_ligacoes == 0) {
                    <div class="estatistica_legenda_descricao text-right">{{ estatistica.valor_litragem | currency: 'BRL' : '' }}</div>
                  }
                  <div class="estatistica_legenda_descricao text-right">{{ estatistica.porcentagem | currency: 'BRL' : '' }}%</div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Listagem de pedidos -->
  @if (stats) {
    <hr class="mt-2 mb-3" />
    @if (!podeListar) {
      <p class="text-secondary text-center">Listagem não disponível para esta tela.</p>
    }
    @if (podeListar) {
      @if (carregandoPedidos) {
        <div class="text-center mt-3 mb-3">
          <span class="text-secondary">Carregando pedidos...</span>
        </div>
      }
      @if (!carregandoPedidos) {
        <div class="table-responsive">
          <table class="table table-sm table-hover tabela_padrao">
            <thead>
              <tr>
                <th class="text-center tabela_borda">Status</th>
                <th class="text-center tabela_borda">Nro Pedido</th>
                <th class="text-center tabela_borda">Nro (ERP)</th>
                <th class="tabela_borda">Vend Externo</th>
                <th class="tabela_borda">Vend Interno</th>
                <th class="tabela_borda">Cliente</th>
                <th class="text-center tabela_borda">CNPJ/CPF</th>
                <th class="text-right tabela_borda">Total: R$</th>
                <th class="text-right tabela_borda">Litragem</th>
                @if (configuracao != null && configuracao.mostra_faturado) {
                  <th class="text-right tabela_borda">Faturado: R$</th>
                }
                <th class="text-center tabela_borda">Enviado</th>
                <th class="text-center tabela_borda">Pedido Programado</th>
                <th class="text-center tabela_borda">Liberado</th>
                <th class="text-center tabela_borda">Integrado</th>
                <th class="tabela_borda">Prazo Pagto</th>
                <th class="text-center tabela_borda">Tipo</th>
                @if (configuracao != null && configuracao.mostra_faturado) {
                  <th class="text-center tabela_borda">Nota Fiscal</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (pedido of pedidos; track pedido) {
                <tr>
                  <td class="text-center tabela_borda">
                    @if (pedido.status_pedido == 'Faturado') {
                      <span class="badge badge-success">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Integrado') {
                      <span class="badge badge-info">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Faturado Div') {
                      <span class="badge badge-other">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Cancelado') {
                      <span class="badge badge-distinct">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'À Integrar') {
                      <span class="badge badge-primary">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Aprov') {
                      <span class="badge badge-warning">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Financeiro') {
                      <span class="badge badge-financeiro">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Gerencial') {
                      <span class="badge badge-gerencial">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Diretor') {
                      <span class="badge badge-diretor">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Coordenador') {
                      <span class="badge badge-coordenador">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Aguard Cad') {
                      <span class="badge badge-secondary">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Erro Integ') {
                      <span class="badge badge-danger">{{ pedido.status_pedido }}</span>
                    }
                    @if (pedido.status_pedido == 'Reprovado') {
                      <span class="badge badge-dark">{{ pedido.status_pedido }}</span>
                    }
                  </td>
                  <td class="text-center tabela_borda">{{ pedido.order_id_app }}</td>
                  <td class="text-center tabela_borda">{{ pedido.id_no_erp_do_cliente }}</td>
                  <td class="tabela_borda">{{ pedido.vend_ext }}</td>
                  <td class="tabela_borda">{{ pedido.vend_int }}</td>
                  <td class="tabela_borda">{{ pedido.name }}</td>
                  <td class="text-center tabela_borda">{{ pedido.client_document }}</td>
                  <td class="text-right tabela_borda">{{ pedido.total | currency: 'BRL' }}</td>
                  <td class="text-right tabela_borda">{{ pedido.total_litragem | currency: 'BRL' : '' }}</td>
                  @if (configuracao != null && configuracao.mostra_faturado) {
                    <td class="text-right tabela_borda">{{ pedido.total_fat | currency: 'BRL' }}</td>
                  }
                  <td class="text-center tabela_borda">{{ pedido.order_sent_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="text-center tabela_borda">{{ pedido.dt_previsao_entrega | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-center tabela_borda">{{ pedido.dt_liberacao_master | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="text-center tabela_borda">{{ pedido.dt_integracao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="tabela_borda">{{ pedido.prazo_pgto }}</td>
                  <td class="text-center tabela_borda">{{ pedido.cod_tipopedvenda }}</td>
                  @if (configuracao != null && configuracao.mostra_faturado) {
                    <td class="text-center tabela_borda">{{ pedido.numero_nf }}</td>
                  }
                </tr>
              }
              @if (pedidos.length === 0) {
                <tr>
                  <td colspan="20" class="text-center text-secondary">Nenhum pedido encontrado.</td>
                </tr>
              }
            </tbody>
          </table>
          <!-- Paginação -->
          <app-pagination
            [page]="page"
            [totalPages]="totalPages"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            [pageSizes]="[20, 50, 100]"
            (pageChange)="carregarPedidos($event)"
            (pageSizeChange)="onPageSizeChange($event)">
          </app-pagination>
        </div>
      }
    }
  }

  <!-- Placeholder antes de gerar -->
  @if (!stats && !gerandoStats) {
    <div class="text-secondary text-center mt-4">
      <p>Selecione os filtros desejados e clique em <b>Gerar Estatísticas</b>.</p>
    </div>
  }

  <!-- Loading -->
  @if (gerandoStats) {
    <div class="text-center mt-4">
      <span class="text-secondary">Gerando estatísticas...</span>
    </div>
  }
</div>
